module.exports = __webpack_public_path__ + "static/media/qianyue.4f7766f6.png";